<div class="account-information-main-container">
  <section class="top-section">
    <img src="/assets/logo/logo-full-green.png" alt="Logo" class="logo" />
  </section>

 <div class="back-home-section">
  <div class="back-button" (click)="back()">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="back-icon">
      <path d="M15.5 18L9.5 12L15.5 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span class="back-text">Back to home</span>
  </div>
</div>

  <div class="flow-container">
    <div class="form-wrapper">
      <section class="account-info-container" [formGroup]="accountForm">
        <h1 class="main-title">Create an account</h1>
        <p class="subtitle">Let's get started with your basic info</p>

        <!-- Error Message -->
        <div class="error-banner" *ngIf="errorMessage">
          <p>{{ errorMessage }}</p>
        </div>

        <!-- First Name -->
        <div class="input-container">
          <label class="input-label">First Name</label>
          <gbui-input
            class="inputs"
            simple
            formControlName="firstName"
            placeholder="Enter first name"
          ></gbui-input>
          <label
            class="error-message"
            *ngIf="
              !accountForm.controls['firstName'].valid &&
              accountForm.controls['firstName'].touched
            "
          >
            Required
          </label>
        </div>

        <!-- Last Name -->
        <div class="input-container">
          <label class="input-label">Last Name</label>
          <gbui-input
            class="inputs"
            simple
            formControlName="lastName"
            placeholder="Enter last name"
          ></gbui-input>
          <label
            class="error-message"
            *ngIf="
              !accountForm.controls['lastName'].valid &&
              accountForm.controls['lastName'].touched
            "
          >
            Required
          </label>
        </div>

        <!-- Password -->
        <div class="input-container">
          <label class="input-label">Password</label>
          <gbui-input
            class="inputs"
            password
            type="password"
            formControlName="password"
            placeholder="Enter password"
          ></gbui-input>
          <label
            class="error-message"
            *ngIf="
              !accountForm.controls['password'].valid &&
              accountForm.controls['password'].touched
            "
          >
            {{ getPasswordErrorMessage('password') }}
          </label>
        </div>

        <!-- Confirm Password -->
        <div class="input-container">
          <label class="input-label">Confirm Password</label>
          <gbui-input
            class="inputs"
            password
            type="password"
            formControlName="confirmPassword"
            placeholder="Confirm password"
          ></gbui-input>
          <label
            class="error-message"
            *ngIf="
              !accountForm.controls['confirmPassword'].valid &&
              accountForm.controls['confirmPassword'].touched
            "
          >
            {{ getPasswordErrorMessage('confirmPassword') }}
          </label>
        </div>

        <!-- Submit Button -->
        <gbui-button
          (click)="createAccount()"
          [disabled]="accountForm.invalid || isLoading"
          class="create-account-button"
          type="button"
        >
          {{ isLoading ? 'Creating Account...' : 'Create Account' }}
        </gbui-button>
      </section>
    </div>
  </div>
</div>
